import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CallState, type AppDispatch } from "@b2bportal/core-types";

import {
  getFetchCfarOffersCallState,
  selectFetchCfarOffersRequest,
} from "../store/selectors";

import { fetchCfarOffersV2 } from "../thunks";

export const useFetchCfarOffersV2Light = () => {
  const dispatch = useDispatch<AppDispatch>();

  const fetchCfarOffersRequest = useSelector(selectFetchCfarOffersRequest);
  const fetchCfarOffersCallState = useSelector(getFetchCfarOffersCallState);

  return useCallback(
    (tripId: string, fareId: string) => {
      if (fetchCfarOffersCallState === CallState.InProcess) {
        return;
      }

      if (fetchCfarOffersCallState === CallState.Success) {
        if (
          fetchCfarOffersRequest &&
          fetchCfarOffersRequest.tripId === tripId &&
          fetchCfarOffersRequest.fareId === fareId
        ) {
          return;
        }
      }

      dispatch(
        fetchCfarOffersV2({
          tripId,
          fareId,
        })
      );
    },
    [dispatch, fetchCfarOffersCallState, fetchCfarOffersRequest]
  );
};
